import usePub from '@/store/Public'
export default defineNuxtRouteMiddleware((to) => {
    
    
    // let title = to.name.toString()
    // title = title.charAt(0).toUpperCase() + title.slice(1)
    // title = title.replace(/-/g, ' ')
    // useMeta({ title });
    // console.log("B");
    // window.scrollTo(0,0)
})